import React, { useEffect, useRef } from 'react'

const Testimonials = () => {
  const insertedRef = useRef(false)
  const containerRef = useRef(null)

  useEffect(() => {
    if (insertedRef.current || !containerRef.current) return
    insertedRef.current = true

    const script = document.createElement('script')
    script.src = 'https://cdn.trustindex.io/loader.js?ce2dee4758d311658d86e2cbd92'
    script.defer = true
    script.async = true
    containerRef.current.parentNode.insertBefore(script, containerRef.current.nextSibling)
  }, [])

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <span className="text-prose-gold font-semibold tracking-widest uppercase text-xs sm:text-sm italic" data-aos="fade-in" data-aos-delay="100">Testimonials</span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-display font-bold mt-3 mb-4 text-prose-black" data-aos="fade-up" data-aos-delay="100">What Our Clients Say</h2>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg max-w-2xl mx-auto" data-aos="fade-up" data-aos-delay="200">Trusted by hundreds of property owners to deliver results and peace of mind</p>
        </div>

        <div 
          ref={containerRef}
          data-aos="fade-up"
          data-aos-delay="300"
        />
      </div>
    </section>
  )
}

export default Testimonials